import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { emptyArray } from 'ui-components/default-props/empty';
import { CUSTOMERS_CREATE_LABEL, LOCAL_DELIVERY_RATE, RATE_BROWSER, RETURNS } from '../../../enums/csw-types';
import ErrorBoundary from '../../error-boundary';
import SellerPresetsHotkey from '../../hotkeys/seller-presets';
import { FulfillmentPlannerContext } from '../../../fulfillment-planner';

import RateCalcLocalDeliveryConfiguration from './local-delivery';
import RateCalcShipmentConfiguration from './shipment';

export const RateCalcFulfillmentConfiguration = React.memo(({ fulfillmentPlanId, returnMetadata }) => {
  const hotkeyedFulfillmentPlanIds = useMemo(() => (!fulfillmentPlanId ? emptyArray : [fulfillmentPlanId]), [fulfillmentPlanId]);

  const CSW_CONFIGURATIONS = {
    [CUSTOMERS_CREATE_LABEL]: RateCalcShipmentConfiguration,
    [LOCAL_DELIVERY_RATE]: RateCalcLocalDeliveryConfiguration,
    [RATE_BROWSER]: RateCalcShipmentConfiguration,
    [RETURNS]: RateCalcShipmentConfiguration,
  };

  return (
    <FulfillmentPlannerContext.Consumer>
      {({ applyPresetConfiguration, cswTypeId, insuranceProvider, isReturn }) => {
        const Component = CSW_CONFIGURATIONS[cswTypeId];
        return (
          <SellerPresetsHotkey fulfillmentPlanIds={hotkeyedFulfillmentPlanIds} onApplyPreset={applyPresetConfiguration}>
            <ErrorBoundary errorMessageId='rateCalcCswShipment'>
              <Component
                fulfillmentPlanId={fulfillmentPlanId}
                insuranceProviderName={insuranceProvider?.name}
                isReturn={isReturn}
                returnMetadata={returnMetadata}
              />
            </ErrorBoundary>
          </SellerPresetsHotkey>
        );
      }}
    </FulfillmentPlannerContext.Consumer>
  );
});

RateCalcFulfillmentConfiguration.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  returnMetadata: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
};
